import Link from 'next/link'
import cx from 'classnames'
import { ArrowLeftLong } from '@/components/svg/arrow-left-long/arrow-left-long'
import { ROUTES } from '@/constants'
import { navItemOnClickGTMEvent } from '@/utils/gtmEvents/navItemOnClickGTMEvent'
import type { ShopMegaMenuData } from '@/types/api/shop-mega-menu'
import { shopMegaMenuLinks } from './shop-mega-menu-links'
// Reuses the mobile category panel's own classes so Shop expands exactly like a
// category does, rather than introducing a second disclosure look.
import mobile from '../main-nav-mobile/main-nav-mobile.module.css'
import s from './nav-shop-mega-menu.module.scss'

type Props = {
  data: ShopMegaMenuData
  isOpen: boolean
  onNavigate: () => void
  registerRef: (slug: string, ref: HTMLDivElement) => void
}

// The Shop panel in the mobile menu: "All Shop", then every collection link.
// No FEATURED cards — the mobile category panels carry links only, and the
// featured slider is desktop-side (`main-nav.tsx`, behind `VisibleOn desktop`).
// A collection that is only featured and not in a column is therefore reached
// from the shop rather than from this menu, as a category's featured articles
// are.
export const NavShopMenuMobile = ({
  data,
  isOpen,
  onNavigate,
  registerRef,
}: Props) => (
  <div
    className={cx(mobile.navList, mobile.navListSubcategory, {
      [mobile.open]: isOpen,
    })}
    ref={(el) => {
      if (el) registerRef('shop', el)
    }}
  >
    <div className={mobile.subcategoryTitle} onClick={onNavigate}>
      <Link
        href={ROUTES.SHOP.ROOT}
        className={mobile.subcategoryTitleLink}
        onClick={() => navItemOnClickGTMEvent('Shop')}
      >
        All Shop
        <ArrowLeftLong
          svgProps={{
            style: { transform: 'rotate(180deg)' },
            width: 16,
            height: 16,
          }}
        />
      </Link>
    </div>

    <ul className={s.mobileLinks}>
      {shopMegaMenuLinks(data).map((link) => (
        <li key={link.slug} className={mobile.navItem} onClick={onNavigate}>
          <Link
            href={ROUTES.SHOP.COLLECTION(link.slug)}
            className={mobile.navLink}
            onClick={() => navItemOnClickGTMEvent(link.title)}
          >
            {link.title}
          </Link>
        </li>
      ))}
    </ul>
  </div>
)
